import { Search, Dumbbell } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
interface ClassesHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  activeView: string;
  setActiveView: (view: string) => void;
  canSubscribe: boolean;
  isTeacher: boolean;
  showSearch?: boolean;
  showScheduleTab?: boolean;
}
export const ClassesHeader = ({
  searchQuery,
  setSearchQuery,
  activeView,
  setActiveView,
  canSubscribe,
  isTeacher,
  showSearch = true,
  showScheduleTab = false
}: ClassesHeaderProps) => {
  return <header className="p-2 pt-16 sm:p-2 sm:pt-16 space-y-4 sm:space-y-5">
      {/* Hero section with icon */}
      <div className="flex flex-col items-center justify-center gap-3 animate-fade-in">
        
        <div className="text-center">
          <h1 className="text-3xl sm:text-4xl font-heading font-bold gradient-text">
            {isTeacher ? "Clases" : "Clases y Reservas"}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {isTeacher ? "Gestiona tus clases y estudiantes" : "Explora y únete a las clases disponibles"}
          </p>
        </div>
      </div>
      
      {(canSubscribe || isTeacher) && <div className="flex justify-center mb-4 px-2 sm:px-0 animate-fade-in stagger-1">
          <ToggleGroup type="single" value={activeView} onValueChange={value => value && setActiveView(value)} className="glass backdrop-blur-md rounded-lg border border-primary/20 inline-flex p-0.5 gap-0.5">
            {isTeacher ? <>
                <ToggleGroupItem value="subscribed" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                  <span className="hidden sm:inline">Mis clases asignadas</span>
                  <span className="sm:hidden">Asignadas</span>
                </ToggleGroupItem>
                <ToggleGroupItem value="created" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                  <span className="hidden sm:inline">Mis clases creadas</span>
                  <span className="sm:hidden">Creadas</span>
                </ToggleGroupItem>
                {showScheduleTab && (
                  <ToggleGroupItem value="schedules" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                    <span className="hidden sm:inline">Mis Horarios</span>
                    <span className="sm:hidden">Horarios</span>
                  </ToggleGroupItem>
                )}
              </> : <>
                <ToggleGroupItem value="all" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                  <span className="hidden sm:inline">Todas las clases</span>
                  <span className="sm:hidden">Todas</span>
                </ToggleGroupItem>
                {canSubscribe && <>
                    <ToggleGroupItem value="subscribed" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                      <span className="hidden sm:inline">Mis clases</span>
                      <span className="sm:hidden">Mis clases</span>
                    </ToggleGroupItem>
                    <ToggleGroupItem value="reservations" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                      Reservas
                    </ToggleGroupItem>
                    <ToggleGroupItem value="my-reservations" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                      <span className="hidden sm:inline">Mis reservas</span>
                      <span className="sm:hidden">Mis reservas</span>
                    </ToggleGroupItem>
                  </>}
                {showScheduleTab && (
                  <ToggleGroupItem value="schedules" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md transition-all duration-300 text-xs sm:text-sm px-2 py-0.5 sm:px-2.5 sm:py-0.5 font-medium hover:bg-primary/10">
                    <span className="hidden sm:inline">Mis Horarios</span>
                    <span className="sm:hidden">Horarios</span>
                  </ToggleGroupItem>
                )}
              </>}
          </ToggleGroup>
        </div>}

      {showSearch && <div className="relative max-w-md mx-auto animate-fade-in stagger-2">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground w-5 h-5" />
          <Input type="search" placeholder="Buscar clases..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-12 py-6 bg-card/50 backdrop-blur-sm border-primary/20 text-foreground placeholder:text-muted-foreground rounded-2xl focus:border-primary/40 focus:ring-primary/20 transition-all" />
        </div>}
    </header>;
};